export default "__VITE_ASSET__DztoE_eS__"